import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { CampaignWizard } from '@/features/surveys/components/CampaignWizard';

export const Route = createFileRoute('/_authenticated/surveys/campaigns/new')({
  component: NewCampaignPage,
});

function NewCampaignPage() {
  const { t } = useTranslation('surveys');
  return (
    <div className="container mx-auto py-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">{t('newCampaign.title')}</h1>
        <p className="mt-1 text-muted-foreground">
          {t('newCampaign.description')}
        </p>
      </div>
      <CampaignWizard />
    </div>
  );
}
